export const environment = {
    GRAPHQL_URI: 'https://izzy-system-api-stage.azurewebsites.net/',
    GRAPHQL_WS_URI: 'wss://izzy-system-api-stage.azurewebsites.net/',
    REDIRECT_URI: 'https://zealous-pebble-0c6db4910.3.azurestaticapps.net/',
    CLIENT_ID: '7e6e6ecf-66ff-4733-9c60-1e6def949897',
    TENANT_ID: 'ff10ade7-5d03-40a9-be28-cb7ab99670b1',
    CLIENT_AUTHORITY: 'https://login.microsoftonline.com/ff10ade7-5d03-40a9-be28-cb7ab99670b1',
    AUTH_TYPE: 'auth0' as const,
    NODE_ENV: 'production',
    AUTOSAVE_DEBOUNCE_MS: 1200,
    SEARCH_DEBOUNCE_MS: 800,
    MIN_SEARCH_LENGTH: 3,
    MJ_CORE_SCHEMA_NAME: '__mj',
    production: true,
    APPLICATION_NAME: 'Izzy Explorer',
    APPLICATION_INSTANCE: 'STAGE',
    AUTH0_DOMAIN: 'auth.meetizzy.ai',
    AUTH0_CLIENTID: '2UDFAPcam99MtIcphrlOAFGzzfEv1Twc'
  };
